import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import StockMap from "@/pages/StockMap";
import Units from "@/pages/Units";
import UnitDetail from "@/pages/UnitDetail";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Sales from "@/pages/Sales";
import Team from "@/pages/Team";
import Settings from "@/pages/Settings";
import ImportPage from "@/pages/ImportPage";
import BulkPriceUpdate from "@/pages/BulkPriceUpdate";
import PublicProjectPresentation from "@/pages/PublicProjectPresentation";
import PublicUnitPresentation from "@/pages/PublicUnitPresentation";
import PresentationLanding from "@/pages/PresentationLanding";
import Reports from "@/pages/Reports";
import OfferPrint from "@/pages/OfferPrint";
import Finance from "@/pages/Finance";
import Leads from "@/pages/Leads";
import Platform from "@/pages/Platform";
import Documents from "@/pages/Documents";
import "@/App.css";

const Wrap = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/p/projects/:id" element={<PublicProjectPresentation />} />
          <Route path="/p/units/:id" element={<PublicUnitPresentation />} />

          <Route path="/" element={<Wrap><Dashboard /></Wrap>} />
          <Route path="/dashboard" element={<Wrap><Dashboard /></Wrap>} />

          <Route path="/projects" element={<Wrap><Projects /></Wrap>} />
          <Route path="/projects/:id" element={<Wrap><ProjectDetail /></Wrap>} />
          <Route path="/stock-map" element={<Wrap><StockMap /></Wrap>} />
          <Route path="/units" element={<Wrap><Units /></Wrap>} />
          <Route path="/units/:id" element={<Wrap><UnitDetail /></Wrap>} />
          <Route path="/offers/:id/print" element={<ProtectedRoute><OfferPrint /></ProtectedRoute>} />
          <Route path="/customers" element={<Wrap><Customers /></Wrap>} />
          <Route path="/customers/:id" element={<Wrap><CustomerDetail /></Wrap>} />
          <Route path="/sales" element={<Wrap><Sales /></Wrap>} />
          <Route path="/finance" element={<Wrap><Finance /></Wrap>} />
          <Route path="/leads" element={<Wrap><Leads /></Wrap>} />
          <Route path="/documents" element={<Wrap><Documents /></Wrap>} />
          <Route path="/platform" element={<ProtectedRoute roles={["super_admin"]}><Layout><Platform /></Layout></ProtectedRoute>} />
          <Route path="/team" element={<Wrap><Team /></Wrap>} />
          <Route path="/presentation" element={<Wrap><PresentationLanding /></Wrap>} />
          <Route path="/reports" element={<Wrap><Reports /></Wrap>} />
          <Route path="/settings" element={<Wrap><Settings /></Wrap>} />
          <Route path="/import" element={<Wrap><ImportPage /></Wrap>} />
          <Route path="/bulk-price" element={<Wrap><BulkPriceUpdate /></Wrap>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
